import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    Select,
    Button,
    Upload,
    Modal,
    InputNumber,
    Checkbox,
    Row,
    Col
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { addStaff } from "./service";
import { getTerritory, getRegion, getTerritoryID } from "./../service";
import _ from "lodash";

const { Option } = Select;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 16 },
        lg: { span: 12 },
    },
};

String.prototype.ucFirst = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0
        },
        sm: {
            span: 16,
            offset: 8
        }
    }
};
const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
        onSuccess("ok");
    }, 0);
};
function success() {
    let secondsToGo = 3;
    const onOkModal = () => {
        window.location.reload();
    }
    const modal = Modal.success({
        title: 'เพิ่มพนักงานขาย เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.reload();
    }, secondsToGo * 1000);
}

function error(message) {
    let secondsToGo = 3;
    const onOkModal = () => {
        modal.destroy();
    }
    const modal = Modal.warning({
        title: "Error: " + message,
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
    }, secondsToGo * 1000);
}
const Addform = (props) => {

    // const Addform = () => {
    const [form] = Form.useForm();
    const [previewVisible, setPreviewVisible] = useState(false)
    const [previewImage, setPreviewImage] = useState('')
    const [previewTitle, setPreviewTitle] = useState('')
    const [fileList, setFileList] = useState([])
    const [load, setLoad] = useState(true)
    const [dataTerritory, setDataTerritory] = useState([])
    const [saleAreaCd, setSaleAreaCd] = useState('')
    const [saleAreaArea, setSaleAreaArea] = useState('')


    const [territory_tID, setTerritory_tID] = useState([])
    const [region_select, setRegion_select] = useState()
    const [territory_select, setTerritory_select] = useState()
    const [territoryName_select, setTerritoryName_select] = useState()

    const [dataRegion, setDataRegion] = useState([])
    const [territory, setTerritory] = useState([])
    const handleCancel = () => setPreviewVisible(false)

    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        // this.setState({
        setPreviewImage(file.url || file.preview)
        setPreviewVisible(true)
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1))
        // });
    };
    const handleChange = ({ fileList }) => {
        setFileList(fileList)
    }
    useEffect(() => {
        // console.log("mount it!");

        function setLoadEffect() {
            setLoad(false)
        }
        function getData() {
            getTerritory().then(res => {
                // console.log("res===", res)
                if (res && res.status === 200) {
                    setDataTerritory(res.data)
                }
            })

            setLoadEffect()
        }
        getData();

        function getRegionDetail() {
            getDataRegion();
        }

        function getDataRegion() {
            getTerritoryID(region_select).then(res => {
                if (res && res.status === 200) {
                    setTerritory(res.data)
                    setLoadEffect()
                }
            })
            getRegion().then(res => {
                if (res && res.status === 200) {
                    setDataRegion(res.data)
                }
            })
        }
        getRegionDetail();

    }, [props]);

    const selectArea = (e, name) => {
        setSaleAreaCd(e)
        setSaleAreaArea(name.territoryname)
    }
    const optionArea = (
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectArea}
        >
            {
                dataTerritory.map((data, index) => {
                    // console.log("dataTerritory", dataTerritory)
                    return (
                        <Option key={index} value={data.tID} territoryname={data.territory}>{data.territory}</Option>
                    );
                })
            }
        </Select>
    )
    const onFinish = (values) => {
        // console.log("Received values of form: ", values);
        var terri = values.territory
        var terriName = []
        terri.map((data, index) => {
            var t_name = _.find(territory, function (t) { return t.tID == terri[index] })
            terriName.push(t_name.territory)
        })

        const formData = new FormData();
        fileList.forEach((item, index) => {
            formData.append('image',
                item.originFileObj
            );
        });
        formData.append('state', 'insert');
        formData.append('empCd', values.empCd);
        formData.append('firstName', values.firstName);
        formData.append('lastName', values.lastName);
        formData.append('firstName_th', values.firstName_th);
        formData.append('lastName_th', values.lastName_th);
        formData.append('phone', values.phone);
        if (values.email == undefined) {
            formData.append('email', '');
        } else {
            formData.append('email', values.email);
        }
        // formData.append('saleAreaCd', terri);
        // formData.append('saleAreaDesc', terriName);  
        terri.forEach((item, index) => {
            formData.append(`saleAreaCd[${index}]`, item);
        });
        terriName.forEach((item, index) => {
            formData.append(`saleAreaDesc[${index}]`, item);
        });

        addStaff(formData)
            .then(res => {
                // console.log("res===", res)
                if (res && res.status === 200) {
                    form.resetFields();
                    setFileList([])
                    success()
                } else {
                    error(res)
                }
            })
    };

    const prefixSelector = (
        <Form.Item name="prefix" noStyle>
            <Select style={{ width: 70 }}>
                <Option value="+66">+66</Option>
                {/* <Option value="87">+87</Option> */}
            </Select>
        </Form.Item>
    );

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    const dd = () => {
        // console.log("state", fileList)
    }

    const propUpload = {
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            return {
                fileList: newFileList,
            };
        },
        beforeUpload: file => {
            setFileList(fileList, file)
            return false;
        },
    };
    const selectRegion = (e, name) => {
        // console.log("e1111", e)
        // console.log("name1111", name)
        setRegion_select(e)
        function getData() {
            getTerritoryID(e).then(res => {
                if (res && res.status === 200) {
                    // console.log("res", res)
                    setTerritory(res.data)
                }
            })
        }
        getData();
    }
    const optionRegion = (
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectRegion}
        >
            {
                dataRegion.map((data, index) => {
                    // console.log("dataRegion", dataRegion)
                    return (
                        <Option key={index} value={data.rID} regionname={data.region}>{data.region}</Option>
                    );
                })
            }
        </Select>
    )
    const onChange = (e) => {
        // console.log('checked = ', e);
        // alert(JSON.stringify(e));
        setTerritory_select(e)

    }

    const optionTerritory = (
        // <Checkbox.Group style={{ width: '100%' }} defaultValue={territory_tID} onChange={onChange}>

        <Checkbox.Group
            style={{ width: '100%' }}
            onChange={onChange}
        >
            <Row>
                {territory.map((data, index) => {
                    return (
                        <Col span={12} key={index}>
                            <Checkbox value={data.tID} territoryname={data.territory}>{data.territory}</Checkbox>
                        </Col>
                    );
                })}
            </Row>
        </Checkbox.Group>
    )

    return (
        <div>
            <Form
                {...formItemLayout}
                form={form}
                name="addStaff"
                onFinish={onFinish}
                initialValues={{
                    residence: ["zhejiang", "hangzhou", "xihu"],
                    prefix: "+66",
                    region: region_select,
                    territory: territory_tID
                }}
                scrollToFirstError
            >
                <Form.Item
                    label="รูปพนักงาน"
                >
                    <Upload {...propUpload}
                        name="addImg"
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        customRequest={dummyRequest}
                        rowKey={fileList}
                        style={{ padding: '0px' }}

                    >
                        {fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                    <Modal
                        visible={previewVisible}
                        title={previewTitle}
                        footer={null}
                        onCancel={handleCancel}
                    >
                        <img style={{ width: '100%' }} src={previewImage} />
                    </Modal>
                </Form.Item>
                <Form.Item
                    name="empCd"
                    label="รหัสพนักงาน"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ รหัสพนักงานขาย!",
                        },
                        {
                            pattern: /^(?:\d*)$/,
                            message: "รหัสพนักงานขาย เป็นตัวเลขเท่านั้น!",
                        },
                        {
                            pattern: /^[\d]{0,9}$/,
                            message: "กรุณาระบุ เป็นตัวเลข 9 หลัก",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="firstName"
                    label="ชื่อ (EN)"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ ชื่อภาษาอังกฤษ!",
                        },
                        {
                            pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-?:\d*]+$/,
                            // pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]+$/i,
                            message: "กรุณาระบุ เป็นภาษาอังกฤษ!",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="lastName"
                    label="นามสกุล (EN)"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ นามสกุลภาษาอังกฤษ!",
                        },
                        {
                            pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-?:\d*]+$/,
                            // pattern: /^[a-zA-Z@~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]+$/i,
                            message: "กรุณาระบุ เป็นภาษาอังกฤษ!",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="firstName_th"
                    label="ชื่อ (TH)"
                    rules={[{
                        required: true,
                        message: "กรุณาระบุ ชื่อภาษาไทย!"
                    }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="lastName_th"
                    label="นามสกุล (TH)"
                    rules={[{
                        required: true,
                        message: "กรุณาระบุ นามสกุลภาษาไทย!"
                    }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="phone"
                    label="เบอร์โทรศัพท์"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ เบอร์โทรศัพท์!"
                        }
                    ]}
                >
                    {/* <Input addonBefore={prefixSelector} style={{ width: "100%" }} /> */}
                    <Input style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item
                    name="email"
                    label="อีเมล์"
                >
                    <Input type="email" />
                </Form.Item>
                {/* <Form.Item
                    name="province"
                    label="เขตการขาย"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ เขตการขาย!",
                        }
                    ]}
                >
                    {optionArea}
                </Form.Item> */}
                <Form.Item
                    name="region"
                    label="พื้นที่รับผิดชอบ"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาเลือก พื้นที่รับผิดชอบ!",
                        }
                    ]}
                >
                    {optionRegion}
                </Form.Item>
                <Form.Item
                    name="territory"
                    label="เขตการขาย"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาเลือก เขตการขาย!",
                        }
                    ]}
                >
                    {region_select ? optionTerritory : <div>"เลือกพื้นที่รับผิดชอบก่อน!"</div>}
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit" style={{ float: 'right' }}>
                        เพิ่มพนักงานขาย
                    </Button>
                </Form.Item>
            </Form>
        </div >
    );
};

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default Addform